import React from 'react'
import { URL_API } from '../../../../services/api_url'
import { useAxiosHttpClient } from '../../../../hooks/useAxiosHttpClient'
import { RemoteStandaloneBillings } from '../../../../data/usecases/StandaloneBillings/RemoteStandaloneBillings'
import { RemoteBankStatementEntries } from '../../../../data/usecases/BankStatementEntries/RemoteBankStatementEntries'
import { ConciliationPage } from '../../../../pages/Conciliation'

export const ConciliationFactory: React.FC = () => {
  const URL = URL_API || 'without-url'
  const httpClient = useAxiosHttpClient()

  // as cobranças avulsas só aparecem no detalhe de um lançamento já vinculado (histórico)
  const standaloneBillings = new RemoteStandaloneBillings(URL, httpClient)
  const bankStatementEntries = new RemoteBankStatementEntries(URL, httpClient)

  document.title = 'PropToken - Conciliação'

  return (
    <ConciliationPage
      standaloneBillings={standaloneBillings}
      bankStatementEntries={bankStatementEntries}
    />
  )
}
